/**
 * Global Search Results DTO
 */
export default class GlobalSearchResults
{
  /**
    * List of grouped entities results
    */
  GroupedEntities: Array<any> = [];
}